import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getSingleDocument, postSubmissionEdit, SubmitRating } from '../../actions/studentdashboard';
import { Link } from 'react-router-dom';
import classname from 'classnames';
import TopNav from '../includes/TopNav.js';
var EditRating = React.createClass({
  getInitialState: function () {
    return {
      rating_star: 1,
      rating_comment: '',
      document_version_doc_version_id: this.props.match.params.DocID
    };
  },
  handleOptionChange: function (changeEvent) {
    this.setState({
      rating_star: changeEvent.target.value
    });
  },
  handleTextField: function(txt){
    this.setState({
      rating_comment: txt.target.value
    });
  },
  handleFormSubmit: function (formSubmitEvent) {
    formSubmitEvent.preventDefault();
    this.props.dispatch(
      SubmitRating(this.state, () => {
        alert("Rating Submitted!")
        this.props.history.push('/studentdashboard/')
      })
    )
  },
  render: function () {
    return (
        <div>
          <TopNav />
          <div className="dashboardpaperdetails">
            <br/>
            <br/>
            Please rate the editors performance on this edit
            <br/>
            <form onSubmit={this.handleFormSubmit}>
              <div>
                <label><input type="radio" className="rating-radio" value={1} checked={this.state.rating_star == 1} onChange={this.handleOptionChange} /> 1 </label>
                <label><input type="radio" className="rating-radio" value={2} checked={this.state.rating_star == 2} onChange={this.handleOptionChange} /> 2 </label>
                <label><input type="radio" className="rating-radio" value={3} checked={this.state.rating_star == 3} onChange={this.handleOptionChange} /> 3 </label>
                <label><input type="radio" className="rating-radio" value={4} checked={this.state.rating_star == 4} onChange={this.handleOptionChange} /> 4 </label>
                <label><input type="radio" className="rating-radio" value={5} checked={this.state.rating_star == 5} onChange={this.handleOptionChange} /> 5 </label>
              </div>
              <textarea onChange={this.handleTextField} className="rating-textarea"></textarea>
              <button className="rating-submitbutton">Submit Rating</button>
            </form>
            <span>
              <Link to="/studentdashboard/">Back</Link>
            </span>
          </div>
        </div>
      )
  }
})

export default connect( ({Dashboard}) => ({Dashboard}) ) (EditRating)

// <ul className="rating-list" >
//   <li className="one">
//       <select><option>Yes</option></select>
//       </li>
//   <li className="two">
//           <select><option>Yes</option></select>
//       </li>
//   <li className="three">
//           <select><option>Yes</option></select>
//       </li>
// </ul>



// WEBPACK FOOTER //
// ./src/components/dashboards/StudentRatingDetails.js